import React from "react";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../gComponents/gButton";

export default function CreatDocType(props) {
  const [openSnackbar] = useSnackbar();

  const initialValues = {
    user_type: props.type ? props.type : "",
    title: !props.isEmpty ? props.data.title : "",
  };

  const onSubmit = (values) => {
    console.log(values);

    var hitMethod = !props.isEmpty ? "PUT" : "POST";
    var hitUrl = !props.isEmpty
      ? "document/types/" + props.data.id
      : "document/types";
    ApiService({ method: hitMethod, route: hitUrl, body: values }).then(
      (response) => {
        console.log("r" + response.data.status_code);
        if (response.data.status_code === 1) {
          props.setDtvisible(false);
          props.onSubmit(response.data.data);
        }
        openSnackbar(response.data.message);
        return;
      }
    );
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
  });

  if (props.dtvisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header">
        {!props.isEmpty ? "Edit" : "Create"} Document Type
      </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form>
            <FormikControl
              control="input"
              type="text"
              label="Title"
              name="title"
            />
            <br />

            <GButton
              type="submit"
              variant="condensed"
              children={!props.isEmpty ? "Update" : "Create"}
              style={{ margin: "0 15px", width: "calc(100% - 30px)" }}
            />
          </Form>
        </Formik>
      </div>
    </>
  );
}
